<template>
  <div class="login-container">
    <div class="main">
      <div class="dmc">IWRS</div>
      <div class="login-box">
        <div class="box">
          <img
            class="boxImg"
            src="../../assets/login/bgLogo.png"
            width="80%"
            alt="图片"
          />
        </div>
        <div class="box">
          <div class="boxImg" style="width: 80%; height: auto;">
            <div class="title">找回密码</div>
            <el-form
              ref="findPwdForm"
              :model="form"
              :rules="rules"
              class="login-form"
              auto-complete="off"
              label-position="left"
            >
              <el-form-item
                prop="phone"
                style="border: 1px solid #a9a9a9; background-color: #fff"
              >
                <span class="svg-container">
                  <i class="el-icon-mobile-phone" style="font-size: 16px; margin-left: 5px;"></i>
                </span>
                <el-input
                  v-model="form.phone"
                  placeholder="请输入手机号"
                  name="phone"
                  type="text"
                  tabindex="1"
                  auto-complete="off"
                />
              </el-form-item>

              <el-form-item
                prop="v_code"
                style="border: 1px solid #a9a9a9; background-color: #fff"
              >
                <span class="svg-container code-icon">
                  <i class="el-icon-chat-dot-square" />
                </span>
                <div class="v-code-row">
                  <el-input
                    v-model="form.v_code"
                    placeholder="请输入验证码"
                    name="v_code"
                    type="text"
                    tabindex="2"
                    auto-complete="off"
                    class="v-code-input"
                  />
                  <span
                    class="code-btn"
                    :class="{ disabled: code !== '获取验证码' }"
                    @click="getCode"
                  >{{ code === '获取验证码' ? code : code + 's' }}</span>
                </div>
              </el-form-item>

              <el-form-item
                prop="password"
                style="border: 1px solid #a9a9a9; background-color: #fff"
              >
                <span class="svg-container">
                  <svg-icon icon-class="password" />
                </span>
                <el-input
                  :key="passwordType"
                  ref="password"
                  v-model="form.password"
                  :type="passwordType"
                  placeholder="请输入新密码"
                  name="password"
                  tabindex="3"
                  auto-complete="off"
                />
                <span class="show-pwd" @click="showPwd('passwordType')">
                  <svg-icon
                    :icon-class="
                      passwordType === 'password' ? 'eye' : 'eye-open'
                    "
                  />
                </span>
              </el-form-item>

              <el-form-item
                prop="password_again"
                style="border: 1px solid #a9a9a9; background-color: #fff"
              >
                <span class="svg-container">
                  <svg-icon icon-class="password" />
                </span>
                <el-input
                  :key="passwordAgainType"
                  ref="password_again"
                  v-model="form.password_again"
                  :type="passwordAgainType"
                  placeholder="请再次输入新密码"
                  name="password_again"
                  tabindex="4"
                  auto-complete="off"
                  @keyup.enter.native="handleFind"
                />
                <span class="show-pwd" @click="showPwd('passwordAgainType')">
                  <svg-icon
                    :icon-class="
                      passwordAgainType === 'password' ? 'eye' : 'eye-open'
                    "
                  />
                </span>
              </el-form-item>

              <div style="display: flex; justify-content: space-between;">
                <el-button
                  :loading="loading"
                  type="primary"
                  style="width: 45%; margin-bottom: 30px"
                  @click.native.prevent="handleFind"
                  >确定</el-button
                >
                <el-button
                  style="width: 45%; margin-bottom: 30px"
                  @click.native.prevent="goCancel"
                  >取消</el-button
                >
              </div>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { sendVerifyCode, modifyPwd } from "@/api/user";

export default {
  name: "FindPwd",
  data() {
    const validatePasswordAgain = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入新密码"));
      } else if (value !== this.form.password) {
        callback(new Error("两次密码输入不一致!"));
      } else {
        callback();
      }
    };
    return {
      code: "获取验证码",
      timer: null,
      form: {
        phone: "",
        v_code: "",
        password: "",
        password_again: "",
      },
      rules: {
        phone: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        v_code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        password: [{ required: true, message: "请输入新密码", trigger: "blur" }],
        password_again: [
          { required: true, trigger: "blur", validator: validatePasswordAgain },
        ],
      },
      loading: false,
      passwordType: "password",
      passwordAgainType: "password",
    };
  },
  methods: {
    showPwd(type) {
      if (this[type] === "password") {
        this[type] = "";
      } else {
        this[type] = "password";
      }
    },
    getCode() {
      if (!this.form.phone) {
        this.$message.error("请输入手机号");
        return;
      }
      if (this.code === "获取验证码") {
        sendVerifyCode({ phone: this.form.phone }).then((res) => {
          if (res && res.code === 0) {
            this.$message.success("验证码发送成功");
            this.code = 60;
            this.timer = setInterval(this.setCode, 1000);
          } else {
            this.$message.error(res.msg || "发送失败");
          }
        });
      }
    },
    setCode() {
      if (typeof this.code === "number") {
        this.code = this.code - 1;
      }
      if (this.code === 0) {
        clearInterval(this.timer);
        this.code = "获取验证码";
      }
    },
    handleFind() {
      this.$refs.findPwdForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          // According to typical modifyPwd endpoint, we should pass phone, code, and new password
          const data = {
            phone: this.form.phone,
            v_code: this.form.v_code,
            password: this.form.password,
            password_again: this.form.password_again
          };
          modifyPwd(data)
            .then((res) => {
              this.loading = false;
              if (res && res.code === 0) {
                this.$notify({
                  title: "成功",
                  message: res.msg || "密码修改成功",
                  type: "success",
                  duration: 2000,
                });
                this.$router.push({ path: "/login" });
              } else {
                this.$message.error(res.msg || "修改失败");
              }
            })
            .catch(() => {
              this.loading = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    goCancel() {
      this.$router.push({ path: "/login" });
    },
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }
};
</script>

<style lang="scss">
$bg: #fff;
$light_gray: #000;
$cursor: #a9a9a9;

@supports (-webkit-mask: none) and (not (cater-color: $cursor)) {
  .login-container .el-input input {
    color: $cursor;
  }
}

.login-container {
  .svg-container {
    margin-left: 10px;
  }

  .code-icon {
    display: inline-flex;
    align-items: center;
    height: 47px;

    i {
      font-size: 16px;
      line-height: 1;
    }
  }

  .el-input {
    display: inline-block;
    height: 47px;
    width: 85%;

    input {
      background: transparent;
      border: 0px;
      -webkit-appearance: none;
      border-radius: 0px;
      padding: 12px 5px 12px 15px;
      color: $light_gray;
      height: 47px;
      caret-color: $cursor;

      &:-webkit-autofill {
        box-shadow: 0 0 0px 1000px $bg inset !important;
        -webkit-text-fill-color: $cursor !important;
      }
    }
  }

  .el-form-item {
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    color: #454545;
  }
}
.v-code-row {
  position: relative;
  display: inline-block;
  width: calc(85% - 34px);
  height: 47px;
  vertical-align: top;
}

.v-code-input {
  width: 100% !important;
  height: 47px;

  ::v-deep .el-input__inner {
    height: 47px;
    line-height: 47px;
    border: none;
    border-radius: 0;
    padding: 12px 135px 12px 15px;
  }
}

.code-btn {
  position: absolute;
  top: 0;
  right: -20px;
  height: 47px;
  line-height: 47px;
  color: #2f80ff;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
  transition: color 0.2s ease;

  &:hover {
    color: #1d6fff;
  }

  &.disabled {
    color: #c0c4cc;
    cursor: not-allowed;
  }
}
</style>

<style lang="scss" scoped>
.login-container {
  width: 100%;
  height: 100%;
  background-image: url("../../assets/login/bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.main {
  background-color: #fff;
  width: 70%;
  height: 70%;
  margin: 0 auto;
  border-radius: 8px;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}
.dmc {
  text-align: right;
  padding: 10px;
  color: #262626;
  font-size: 18px;
  font-weight: bold;
}
.login-box {
  display: flex;
  width: 100%;
  height: 92%;
}
.box {
  width: 50%;
  height: 100%;
}
.boxImg {
  display: block;
  margin: 0 auto;
  position: relative;
  height: 60%;
  top: 50%;
  transform: translateY(-50%);
}
.title {
  color: #262626;
  font-weight: bold;
  font-size: 20px;
  text-align: center;
  width: 100%;
  margin-bottom: 20px;
}
.login-form {
  position: relative;
  width: 520px;
  max-width: 100%;
  padding: 20px 35px 0;
  margin: 0 auto;
  overflow: hidden;
}
.show-pwd {
  position: absolute;
  right: 10px;
  top: 7px;
  font-size: 16px;
  cursor: pointer;
  user-select: none;
}
</style>
